module.exports = __webpack_public_path__ + "static/img/0000趣拍拍.4f99a95.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/picImgs/0000趣拍拍.jpg
// module id = Lv9V
// module chunks = 0